// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1__e487d3c6561c55349267","cls2":"CollapsedActivityPreview-cls2__bfdb9f534496404d35c7 CollapsedActivityPreview-cls1__e487d3c6561c55349267"};